import React from 'react';

function SiteHead() {
  React.useEffect(() => {
    // Dynamically create favicon
    const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = 'image/png';
    link.rel = 'shortcut icon';
    link.href = 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><rect width="100" height="100" fill="%234361EE" rx="20" ry="20" /><text x="50" y="55" font-family="Arial, sans-serif" font-size="35" font-weight="bold" text-anchor="middle" fill="white">C</text></svg>';
    document.head.appendChild(link);
    
    // Fix manifest logos
    const patchManifest = () => {
      const manifestEl = document.querySelector('link[rel="manifest"]');
      if (manifestEl) {
        fetch(manifestEl.href)
          .then(response => response.json())
          .then(manifest => {
            manifest.icons = manifest.icons || [];
            
            // Clear existing icons
            manifest.icons = manifest.icons.filter(icon => 
              !icon.src.includes('logo192.png') && !icon.src.includes('logo512.png')
            );
            
            // Add new dynamic icons
            manifest.icons.push({
              src: 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 192"><rect width="192" height="192" fill="%234361EE" rx="16" ry="16" /><text x="96" y="108" font-family="Arial, sans-serif" font-size="28" font-weight="bold" text-anchor="middle" fill="white">CMA</text></svg>',
              sizes: '192x192',
              type: 'image/svg+xml'
            });
            
            // Create Blob URL for the modified manifest
            const blob = new Blob([JSON.stringify(manifest)], {type: 'application/json'});
            const url = URL.createObjectURL(blob);
            
            // Update manifest link
            const newManifestEl = document.createElement('link');
            newManifestEl.rel = 'manifest';
            newManifestEl.href = url;
            
            // Replace old manifest
            manifestEl.remove();
            document.head.appendChild(newManifestEl);
          })
          .catch(err => console.error('Error patching manifest:', err));
      }
    };
    
    // Run after a short delay to ensure manifest is loaded
    setTimeout(patchManifest, 500);
    
    return () => {
      // Cleanup is not needed as we're only adding elements to the DOM
    };
  }, []);
  
  return null;
}

export default SiteHead;